export default {
  ngirkartUrl: "https://www.ngirkart.no/",
  adaptiveUrl: "https://www.nordhordlandskart.no/",
  routeServiceUrl:
    "https://p-dt-ngir-tools-gfbne7cabsfkdwek.norwayeast-01.azurewebsites.net",
  search: {
    searchUrl: "https://av-crawler-search.azurewebsites.net/api/search",
    index: "page",
    domain: "www.ngir.no"
  },
  appName: "NGIR",
  cmsSiteId: 1,
  mapProjCode: "3857",
  mapProjection: "EPSG:3857",
  minZoom: 3,
  maxZoom: 18,
  fitViewAndZoom: {
    in: 18,
    out: 14
  },
  initExtent: [597216, 8421807, 865421, 8813002],
  themes: {
    forsidelenker: {
      uuid: "24edb1ad-7dda-421b-8d25-4ed84ec40266",
      columns: ["uri", "image", "text", "priority"]
    },
    kommuneareal: {
      uuid: "5cd0bda0-c25d-4552-8880-049dae9faf94",
      columns: ["komm", "navn", "oppdateringsdato"],
      intersectFilter: {
        name: "geometri",
        comparisonOperator: "ST_INTERSECTS",
        netType: "geometry",
        logicalOperator: "AND",
        value: undefined
      }
    },
    gjenvinningsstasjoner: {
      uuid: "c92d8c5b-ab35-41eb-b849-20c5ba37f057",
      columns: [
        "navn",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "lordag",
        "sondag",
        "unntak",
        "gjenvinningsstasjon",
        "bilbatvrak",
        "is_naering",
        "is_privat",
        "sort",
        "description",
        "uri",
        "id"
      ],
      filter: {
        sortColumns: [
          {
            name: "sort"
          }
        ]
      }
    },
    varsel: {
      uuid: "2549e6d6-fcc1-4dc7-8c1c-56a18810379a",
      columns: [
        "id",
        "name",
        "textmessage",
        "statuscode",
        "errormessage",
        "comment",
        "send_date",
        "created_date",
        "sent_to",
        "sent_to_type"
      ],
      filter: {
        sortColumns: [
          {
            name: "id"
          }
        ]
      }
    },
    hentedag: {
      uuid: "b40744b8-2d70-441e-89c0-0414b4911df6",
      columns: [
        "fraksjon_dynamisk",
        "fraksjon_dynamisk_neste",
        "sone_ngir_2017",
        "hentedag",
        "hentedag_nesteveke",
        "kommentar",
        "aktuelluke",
        "nesteuke"
      ],
      intersectFilter: {
        name: "geom",
        comparisonOperator: "ST_INTERSECTS",
        netType: "geometry",
        logicalOperator: "AND",
        value: undefined
      }
    },
    konteinerleie: {
      uuid: "da454e6b-a1db-4ea2-b3d1-7bec79e487ab",
      columns: [
        "pristilti",
        "pristilfortifem",
        "pristiinkmva",
        "prisfortifeminkmva",
        "pristieksmva",
        "prisfortifemeksmva",
        "sone"
      ],
      intersectFilter: {
        name: "geom",
        comparisonOperator: "ST_INTERSECTS",
        netType: "geometry",
        logicalOperator: "AND",
        value: undefined
      }
    },
    glasskonteinere: {
      uuid: "a11fce13-244a-46fc-ab5f-1922c2b98978",
      columns: ["volum", "kommune", "uker", "farge", "lenke"]
    },
    varhaustrydding: {
      uuid: "8842e05e-9859-464c-9af8-4060b1b0c2ea",
      columns: ["id", "navn", "hdato", "kommentar"],
      intersectFilter: {
        name: "geom",
        comparisonOperator: "ST_INTERSECTS",
        netType: "geometry",
        logicalOperator: "AND",
        value: undefined
      }
    },
    hyttekonteinarar: {
      uuid: "a81aa4a5-e75d-4372-8bfb-b90658006354",
      columns: ["id", "name", "route"],
      intersectFilter: {
        name: "geom",
        comparisonOperator: "ST_INTERSECTS",
        netType: "geometry",
        logicalOperator: "AND",
        value: undefined
      }
    },

    eternit: {
      uuid: "b52d1076-4ca0-4522-b581-6d8d019adf83",
      columns: [
        "navn",
        "kommunenavn",
        "hdato",
        "tidsrom",
        "datofra",
        "datotil",
        "linkngir",
        "kommentar",
        "tidsrom"
      ]
    },
    aktuelt: {
      uuid: "daad3aeb-bcbc-4616-accc-26ac2028c983",
      columns: [
        "id",
        "tittel",
        "innhold",
        "aktiv",
        "prioritet",
        "bilde",
        "date_created",
        "kategorier"
      ]
    },
    nyhetskategori: {
      uuid: "16e9a80c-77e7-4325-8a95-2ce765e7d65b",
      columns: ["id", "tag"]
    },
    nyheter: {
      uuid: "50f299c0-2343-4549-9371-d22e93c3b428",
      columns: ["id", "tittel", "innhold", "aktiv", "bilde", "date_created"]
    }
  },
  forms: {
    bestillingSkjema: {
      uuid: "c959a954-b95d-4b54-9b0b-c309c16d7721"
    },
    fritakSkjema: {
      uuid: "32bac3f7-e99f-4ac0-8a0c-d1aeed9fcdc8"
    },
    slamtommingSkjema: {
      uuid: "bb21ebe7-7d0c-4360-b604-d8887b522d05"
    },
    minirenseanleggSkjema: {
      uuid: "a8886f0c-7dbe-4b0d-84b8-21c6586e3d14"
    },
    kompostSkjema: {
      uuid: "b824baf6-34eb-494b-b4ee-c60a56050644"
    }
  },
  nav: {
    hushald: { title: "Hushald", uri: "/hushald" },
    hytte: { title: "Hytte", uri: "/hytte" },
    avvik: { title: "MELD AVVIK", uri: "/meldingsteneste" },
    naering: {
      title: "Næring",
      uri: "/naering",
      links: [
        { title: "leigecontainerar", uri: "/leigekonteinar" },
        { title: "steinsandgrus", uri: "/steinsandoggrus" },
        { title: "bilvrak", uri: "/bilvrak" },
        { title: "batvrak", uri: "/batvrak" }
      ]
    },
    navigation: {
      services: [
        { title: "Gjenvinningsstasjonar", uri: "/gjenvinningsstasjonar" },
        {
          title: "Adgangsbevis: NGIR-kort / MiljøID-app",
          uri: "/adgangsbevis"
        },
        {
          title: "Tømmekalender",
          uri: "/tommekalender"
        },
        { title: "SMS-varsel frå NGIR", uri: "/smsvarsel" }
      ],
      questions: [
        { title: "Slik sorterer du", uri: "/slik-sorterer-du" },
        {
          title: "Ofte stilte spørsmål",
          uri: "/ofte-stilte-sporsmal"
        },
        { title: "Er du utbyggjar?", uri: "/er-du-utbyggjar" }
      ],
      us: [
        {
          title: "Skulebesøk, strandrydding og berekraft",
          uri: "/strandryddingogskulebesok"
        },
        { title: "Jobba hjå NGIR?", uri: "/jobb" },
        { title: "Om oss", uri: "/omoss" }
      ]
    }
  }
};
